import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import axios from "axios";

import * as actions from "./actiontypes";
import * as models from "./model";
import { immunisationTypeApi } from "./immunisationTypeApi";

import { push } from "redux-little-router";

export type ImmunisationTypeAction =
      ({ type: typeof actions.LOAD_IMMUNISATIONTYPES_SUCCESS } & Payload<models.ImmunisationTypeListModel[]>)
    | ({ type: typeof actions.CREATE_IMMUNISATIONTYPE_SUCCESS } & Payload<models.ImmunisationTypeDetailModel>)
    | ({ type: typeof actions.LOAD_IMMUNISATIONTYPE_DETAIL_SUCCESS } & Payload<models.ImmunisationTypeDetailModel>)
    | ({ type: typeof actions.SAVE_IMMUNISATIONTYPE_SUCCESS } & Payload<models.ImmunisationTypeDetailModel>);

export const loadImmunisationTypesSuccess = (payload: models.ImmunisationTypeListModel[]): ImmunisationTypeAction => ({
    payload,
    type: actions.LOAD_IMMUNISATIONTYPES_SUCCESS
});

export const createImmunisationTypeSuccess = (payload: models.ImmunisationTypeDetailModel): ImmunisationTypeAction => ({
    payload,
    type: actions.CREATE_IMMUNISATIONTYPE_SUCCESS
});

export const saveImmunisationTypeSuccess = (payload: models.ImmunisationTypeDetailModel): ImmunisationTypeAction => ({
    payload,
    type: actions.SAVE_IMMUNISATIONTYPE_SUCCESS
});

export function createImmunisationType(immunisationType: models.ImmunisationTypeCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_IMMUNISATIONTYPE, immunisationTypeApi.create(immunisationType));
        dispatch(createImmunisationTypeSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveImmunisationType(immunisationType: models.ImmunisationTypeEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_IMMUNISATIONTYPE, immunisationTypeApi.save(immunisationType));

        dispatch(saveImmunisationTypeSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function loadImmunisationTypes() {
    return async (dispatch: Dispatch) => {
        try {
            const result = await loadAndTrack(dispatch, "loadImmunisationTypes", immunisationTypeApi.getAll());
            dispatch(loadImmunisationTypesSuccess(result));
        } catch (ex) {
            if (!(ex instanceof axios.Cancel)) { // eslint-disable-line import/no-named-as-default-member
                throw ex;
            }
        }
    };
}

export const loadImmunisationTypeDetailSuccess = (immunisationType: models.ImmunisationTypeDetailModel) => ({
    payload: immunisationType,
    type: actions.LOAD_IMMUNISATIONTYPE_DETAIL_SUCCESS
});

export function loadImmunisationTypeDetail({ immunisationTypeId }: { immunisationTypeId: string }) {
    return async (dispatch: Dispatch, getState: () => models.AppState) => {
        const immunisationType = getState().immunisationTypes.filter(c => c.id === immunisationTypeId)[0];

        if (immunisationType === undefined
            || !("detailUpdated" in immunisationType)
            || immunisationType.detailUpdated.isBefore(immunisationType.listUpdated)) {

            const action = immunisationType === undefined ? createImmunisationTypeSuccess : loadImmunisationTypeDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadImmunisationTypeDetail", immunisationTypeApi.detail(immunisationTypeId));
            dispatch(action(result));
        }
    };
}
